module.exports = __webpack_public_path__ + "img/transparent-temp-logo-with-title.0e46a353.png";